<div class="p-4">
  <!-- Loading -->
  @if (loadingNotifications()) {
    <div class="flex items-center justify-center py-12 text-left text-gray-500">
      <span class="animate-pulse">Loading notifications...</span>
    </div>
  }

  <!-- Error -->
  @else if (errorLoadingNotifications()) {
    <div class="flex items-center justify-center py-12 text-red-600">Failed to load notifications.</div>
  }

  <!-- Empty -->
  @else if (notifications().length === 0) {
    <div class="flex items-center justify-center py-12 text-gray-500">No notifications yet.</div>
  }

  <!-- List -->
  @else {
    <ul class="max-w-3xl space-y-3">
      @for (notification of notifications(); track notification.id) {
        <li
          (click)="markAsRead(notification.id)"
          class="cursor-pointer rounded-lg border border-gray-500 bg-white p-4 shadow transition hover:bg-gray-200"
          [class.bg-gray-200]="!notification.isRead"
          [class.border-gray-200]="!notification.isRead">
          <div class="flex items-start justify-between gap-4">
            <div class="flex-1">
              <h4 class="text-sm font-semibold text-gray-900">
                {{ isArabic() ? notification.subjectAr : notification.subjectEn }}
              </h4>

              <p class="mt-1 text-sm text-gray-600">
                {{ isArabic() ? notification.bodyAr : notification.bodyEn }}
              </p>
            </div>

            <span class="text-xs whitespace-nowrap text-gray-400">
              {{ notification.createdOn }}
            </span>
          </div>

          <!-- Unread badge -->
          @if (!notification.isRead) {
            <div class="mt-2 inline-block rounded-full bg-blue-100 px-2 py-0.5 text-xs font-medium text-blue-700">
              {{ isArabic() ? "غير مقروءة" : "Unread" }}
            </div>
          }
        </li>
      }
    </ul>

    <div class="mt-6 flex max-w-3xl items-center justify-between">
      <button
        class="rounded bg-gray-200 px-4 py-2 text-sm disabled:opacity-50"
        (click)="prevPage()"
        [disabled]="pageOffset() === 0">
        Previous
      </button>

      <span class="text-sm text-gray-600">Page {{ pageOffset() + 1 }} of {{ totalPages() + 1 }}</span>

      <button
        class="rounded bg-gray-200 px-4 py-2 text-sm disabled:opacity-50"
        (click)="nextPage()"
        [disabled]="pageOffset() + 1 >= totalPages()">
        Next
      </button>
    </div>
  }
</div>
